<p-dialog [(visible)]="show" (onHide)="cartService.hide()" [modal]="true" [resizable]="true">
  <ng-template pTemplate="header">
    @if (cartService.editMode()) {
      <h4 i18n="@@editCart" class="uppercase">Modifier mon panier</h4>
    } @else {
      <h4 i18n="@@addToCart" class="uppercase">Ajouter au panier</h4>
    }
  </ng-template>
  <form [formGroup]="cartForm">
    @if (product) {
      <div>
        <div class="flex justify-content-between align-items-center border-bottom-1 border-cvbg-secondary">
          <h4 class="flex flex-column justify-content-center">
            <span>{{ product.nomVin }}</span>
            <span>{{ product.millesime }}</span>
          </h4>
          <div class="couleur {{product.couleur?.toLowerCase()}}"></div>
        </div>

        <div class="flex flex-column my-3 gap-3 text-xs">
          @if ((responsiveService.isDeviceSmall$() | async)?.matches && s_campagneProduct()) {
            <div class="flex justify-content-between align-items-center uppercase">
              <p i18n="@@sorties" class="text-2xs text-cvbg-secondary">Sorties</p>
              <p>{{ s_campagneProduct()?.dateSortieCampagne | date: 'shortDate' }}</p>
            </div>

            <div class="flex justify-content-between align-items-center">
              <p i18n="@@disponibilites" class="text-2xs text-cvbg-secondary uppercase">Disponibilités</p>
              <p>{{ s_campagneProduct() | statutStock }}</p>
            </div>
          }
          <div class="flex justify-content-between align-items-center">
            @if(cartService.type() === TypeCampagne.Primeurs) {
              <div class="flex flex-column text-cvbg-secondary uppercase">
                @if(s_me()?.unite_Extranet !== 'CS'){
                  <p i18n="@@prix" class="text-2xs">Prix</p>
                  <p i18n="@@tableEq75cl" class="text-3xs">(éq 75cl)</p>
                }
                @else {
                  <p i18n="@@prix/caisse" class="text-2xs">Prix/caisse</p>
                }
              </div>
              <p>{{ (s_campagneProduct() ? s_campagneProduct()?.prixEq75 : s_productCart()?.prix) | dynamicCurrency }}</p>
            }
            @if (cartService.type() === TypeCampagne.MiseEnMarche) {
              <div class="flex flex-column text-cvbg-secondary uppercase">
                @if(s_me()?.unite_Extranet !== 'CS'){
                  <p i18n="@@prix" class="text-2xs">Prix</p>
                  <p i18n="@@tableCol" class="text-3xs">(Col.)</p>
                }
                @else {
                  <p i18n="@@prix/caisse" class="text-2xs">Prix/caisse</p>
                }
              </div>
              <p>{{ (s_campagneProduct() ? s_campagneProduct()?.prixReventeCampagne : s_productCart()?.prix) | dynamicCurrency }}</p>
            }
            @if (!cartService.type()) {
              <div class="flex flex-column text-cvbg-secondary uppercase">
                @if(s_me()?.unite_Extranet !== 'CS'){
                  <p i18n="@@prix" class="text-2xs">Prix</p>
                  <p i18n="@@tableCol" class="text-3xs">(Col.)</p>
                }
                @else {
                  <p i18n="@@prix/caisse" class="text-2xs">Prix/caisse</p>
                }
              </div>
              <p>{{ (s_tarif() ? s_tarif()?.prix : s_productCart()?.prix) | dynamicCurrency }}</p>
            }
          </div>

          <div class="flex justify-content-between align-items-center">
            <p i18n="@@cond" class="text-cvbg-secondary text-2xs uppercase">Cond.</p>

            @if (cartService.type() && cartService.type() === TypeCampagne.Primeurs) {
              <p-dropdown
                i18n-placeholder="@@cond"
                (onChange)="setFormat()"
                [options]="conditionnements()"
                optionValue="label"
                placeholder="Cond."
                appendTo="body"
                formControlName="conditionnement"
                class="w-8"
                panelStyleClass="uppercase"
                styleClass="w-full"
                (onShow)="isConditionOpen = true"
                (onHide)="isConditionOpen = false"
                [dropdownIcon]="isConditionOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
              >

                <ng-template pTemplate="selectedItem">
                  <p>{{cartForm.controls['conditionnement'].value}}</p>
                </ng-template>

                <ng-template let-item pTemplate="item">
                  <p>{{ item.label }}</p>
                </ng-template>

              </p-dropdown>
            } @else {
              <p class="uppercase">{{ cartForm.controls['conditionnement'].value}}</p>
            }
          </div>

          <div class="flex justify-content-between align-items-center">

            <p i18n="@@format" class="text-cvbg-secondary text-2xs uppercase">Format</p>
            @if (cartService.type() && cartService.type() === TypeCampagne.Primeurs) {
              <p-dropdown
                i18n-placeholder="@@format"
                i18n-emptyMessage="@@selectionnerConditionnement"
                [options]="formats()"
                (onChange)="setQuantity()"
                optionValue="value"
                optionLabel="label"
                placeholder="format"
                appendTo="body"
                formControlName="centilisation"
                class="w-8"
                emptyMessage="Sélectionner un conditionnement"
                panelStyleClass="uppercase"
                styleClass="w-full"
                (onShow)="isQteOpen = true"
                (onHide)="isQteOpen = false"
                [dropdownIcon]="isQteOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
              >
              </p-dropdown>
            } @else {
              <p>{{ cartForm.controls['centilisation'].value | centilisation}}</p>
            }
          </div>

          <div class="flex justify-content-between align-items-center">
            <div class="flex flex-column uppercase">
              <p i18n="@@quantite" class="text-cvbg-secondary text-2xs">Quantité</p>
              <p i18n="@@uniteCond" class="text-cvbg-secondary text-3xs">/ Unité cond.</p>
            </div>
            <div class="w-8">
              <p-inputNumber [min]="1"
                             [showButtons]="true"
                             (onInput)="setQuantity()"
                             formControlName="quantity"
                             class="w-full"
                             styleClass="w-full"
                             inputStyleClass="w-8 text-center"
                             decrementButtonClass="w-1rem mr-1 text-3xs"
                             incrementButtonClass="w-1rem ml-1 text-3xs"
                             decrementButtonIcon="fa-solid fa-minus"
                             incrementButtonIcon="fa-solid fa-plus"
                             buttonLayout="horizontal">
              </p-inputNumber>
            </div>
          </div>
          <div class="flex justify-content-between align-items-center">
            <div class="flex flex-column text-cvbg-secondary uppercase">
              <p i18n="@@quantite" class="text-2xs">Quantité</p>
              @if (cartService.type() === TypeCampagne.Primeurs) {
                <p i18n="@@eq75cl" class="text-3xs">/ éq 75cl</p>
              } @else {
                <p i18n="@@col" class="text-3xs">/ col.</p>
              }
            </div>
            <p>{{ qty() | number:'1.0-0' }}</p>
          </div>
        </div>
      </div>
    }
  </form>
  <ng-template pTemplate="footer">
    <p-button [disabled]="cartForm.invalid"
              (onClick)="saveCart()"
              type="submit"
              styleClass="w-full p-3 text-sm"
              label="{{ s_labelSave() }}"
              iconPos="right"
              icon="fa-solid fa-cart-shopping">
    </p-button>
  </ng-template>
</p-dialog>
